module.exports = __webpack_public_path__ + "img/6.864d9e10.svg";